/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_ERROR_OR_DESTRUCT } from '../../styles/colors/colors';
export var StyledNotification = styled('div')(function () {
  return {
    '&.EmbersHeader-notification-root': {
      marginLeft: 'auto',
      color: PROMETHEAN_NEUTRAL_WHITE,
      position: 'relative',
      cursor: 'pointer'
    },
    '.EmbersHeader-notification-count': {
      position: 'absolute',
      top: 3,
      left: -1,
      backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
      borderRadius: '50%',
      width: 10,
      height: 10
    },
    '.EmbersHeader-notification-count [class^="icon-"]': {
      position: 'absolute',
      top: -3,
      left: -3,
      color: PROMETHEAN_ERROR_OR_DESTRUCT,
      fontSize: 16
    }
  };
});